import React from 'react';
import {
  drawPolygon,
  removeGeometry,
  runHistogram,
  fileUpload
} from '../../controllers/esriMapController';
import './ShapeControls.scss';
import ReportControls from '../ReportControls/ReportControls';
import { yearsAvailableForAnalysis } from '../../config/staticText.config';
import AnalyzeInstructions from '../AnalyzeInstructions/AnalyzeInstructions';

const ShapeControls = ({
  charts,
  precalculatedCSVData,
  precalculatedShape,
  histogramResults,
  snapshot,
  totalArea,
  userDrawnPolygon,
  updateYearsSelected,
  yearsSelected
}) => {
  const showAreaSegments =
    (totalArea > 0 || precalculatedCSVData) &&
    charts.totalPlowprintArea > 0 &&
    charts.totalExpansionArea > 0 &&
    charts.totalIntactArea > 0;

  return (
    <div className="instructions-tab__container">
      <AnalyzeInstructions />
      <div className="year-options">
        Select Year Range
        <select
          className="pointer"
          onChange={evt =>
            updateYearsSelected({
              start: parseInt(evt.target.value),
              end: yearsSelected.end
            })
          }
        >
          {yearsAvailableForAnalysis
            .filter(year => year <= yearsSelected.end)
            .sort()
            .map(year => (
              <option key={'year' + year} value={year}>
                {year}
              </option>
            ))}
        </select>
        <div>&#8213;</div>
        <select
          className="pointer"
          onChange={evt =>
            updateYearsSelected({
              start: yearsSelected.start,
              end: parseInt(evt.target.value)
            })
          }
        >
          {yearsAvailableForAnalysis
            .sort()
            .reverse()
            .filter(year => year >= yearsSelected.start)
            .map(year => (
              <option key={'year' + year * 2} value={year}>
                {year}
              </option>
            ))}
        </select>
      </div>

      {!userDrawnPolygon.__accessor__ && (
        <div className="report-options pointer">
          <div
            className="upload-shapefile"
            type="file"
            placeholder="Custom Shape"
            onClick={() => document.getElementById('file-upload').click()}
          >
            Choose Shapefile
            <div className="upload-icon" />
          </div>
          <input
            className="file-upload"
            id="file-upload"
            type="file"
            style={{ display: 'none' }}
            onChange={e => fileUpload(e)}
          />
          <div
            className="custom-drawing-button button"
            onClick={() => drawPolygon()}
          >
            <span>Start Drawing</span>
            <div className="start-drawing-icon" />
          </div>
        </div>
      )}
      <div className="report-options">
        <div
          className="remove-geometry-button button pointer"
          onClick={() => removeGeometry()}
        >
          <span>Remove Geometry</span>
          <div className="delete-geometry pointer" />
        </div>
        <div
          className="run-analysis-button button pointer"
          onClick={() => runHistogram(yearsSelected.start, yearsSelected.end)}
        >
          Run Analysis
        </div>
      </div>

      {/* The areas are on a redux "charts" property. It should be renamed something clearer if we have time later on */}
      {showAreaSegments && (
        <div className="area-summary-container">
          <span className="area-summary-title">Area Summaries:</span>
          <div className="area-summary-item">
            <p>Total Area:</p>{' '}
            <p>
              {totalArea.toLocaleString()} ac ({yearsSelected.end})
            </p>
          </div>
          <div className="area-summary-item">
            <p>Plowprint Extent: </p>{' '}
            <p>
              {charts.totalPlowprintArea.toLocaleString()} ac (
              {yearsSelected.end})
            </p>
          </div>
          <div className="area-summary-item">
            <p>Plowprint Expansion: </p>{' '}
            <p>
              {charts.totalExpansionArea.toLocaleString()} ac ('
              {yearsSelected.start.toString().slice(2)} - '
              {yearsSelected.end.toString().slice(2)})
            </p>
          </div>
          <div className="area-summary-item">
            <p>Intact Habitat: </p>{' '}
            <p>
              {charts.totalIntactArea.toLocaleString()} ac ({yearsSelected.end})
            </p>
          </div>
        </div>
      )}

      {charts && Object.keys(charts).length > 0 && (
        <ReportControls
          charts={charts}
          precalculatedShape={precalculatedShape}
          precalculatedCSVData={precalculatedCSVData}
          histogramResults={histogramResults}
          snapshot={snapshot}
          totalArea={totalArea}
          yearsSelected={yearsSelected}
        />
      )}
    </div>
  );
};

export default ShapeControls;
